import { Inject, Injectable } from '@angular/core'
import jwtDecode from 'jwt-decode'
import { User } from '../models'
import { SBS_ENVIRONMENT } from '../../sbs-common.module'
import { SbsEnvironment } from '../models/sbs-environment'

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor(@Inject(SBS_ENVIRONMENT) private env: SbsEnvironment) {}

  public getAccessToken(): string | null {
    return window.localStorage.getItem(this.env.accessTokenKey)
  }

  public saveAccessToken(token: string): void {
    window.localStorage.removeItem(this.env.accessTokenKey)
    window.localStorage.setItem(this.env.accessTokenKey, token)
  }

  public getRefreshToken(): string | null {
    return window.localStorage.getItem(this.env.refreshTokenKey) ?? ''
  }

  public saveRefreshToken(token: string): void {
    window.localStorage.removeItem(this.env.refreshTokenKey)
    window.localStorage.setItem(this.env.refreshTokenKey, token)
  }

  signOut(): void {
    window.localStorage.removeItem(this.env.accessTokenKey)
    window.localStorage.removeItem(this.env.refreshTokenKey)
  }

  public getUser() {
    try {
      const user = jwtDecode(this.getAccessToken() as string) as User
      return user
    } catch (e) {
      return null
    }
  }

  public getUserFromRefreshToken() {
    try {
      const user = jwtDecode(this.getRefreshToken() as string) as User
      return user
    } catch (e) {
      return null
    }
  }
}
